import {
  GET_APPOINTMENT_LIST,
  GET_APPOINTMENT_LIST_FAILURE,
  GET_APPOINTMENT_LIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getAppointmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_APPOINTMENT_LIST:
      return { ...state, loading: true };
    case GET_APPOINTMENT_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_APPOINTMENT_LIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getAppointmentReducer;
